import { circleQuestion } from "@simplybusiness/icons";
import { Button, Flex, Icon, Popover } from "@simplybusiness/mobius";
import type { ReactNode } from "react";

type CardPopoverProps = {
  toggleText: string;
  body: ReactNode;
  onOpen?: () => void;
  toggleIcon?: boolean;
  isCoreCover?: boolean;
};

export const CardPopover = ({
  toggleText,
  body,
  onOpen,
  toggleIcon = true,
  isCoreCover = false,
}: CardPopoverProps) => (
  <Flex gap="xxs">
    <Popover
      className="mobius-quote-card__info-popover"
      trigger={
        <Button variant="ghost" className="mobius-quote-card__modal-trigger">
          <Flex>
            <span
              className={
                isCoreCover ? "" : "mobius-quote-card__explainer-title"
              }
            >
              {toggleText}
            </span>{" "}
            {toggleIcon && (
              <Icon
                icon={circleQuestion}
                size="sm"
                className="mobius-quote-card__explainer-icon"
              />
            )}
          </Flex>
        </Button>
      }
      onOpen={onOpen}
    >
      {body}
    </Popover>
  </Flex>
);
